import { Check, FileText, Loader2 } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

export default function RecentUploads({ uploads }) {
  if (!uploads.length) return null;

  return (
    <section
      data-testid="recent-uploads"
      className="card-soft rounded-3xl px-6 py-5"
    >
      <div className="eyebrow mb-3">Recent uploads</div>
      <ul className="flex flex-col gap-2">
        <AnimatePresence initial={false}>
          {uploads.map((u) => {
            const done = u.progress >= 100;
            return (
              <motion.li
                key={u.id}
                data-testid={`recent-upload-${u.id}`}
                initial={{ opacity: 0, y: -4 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.18 }}
                className="flex items-center gap-3 rounded-2xl border border-black/[0.04] bg-white px-3 py-2.5"
              >
                <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-zinc-100 text-zinc-700">
                  <FileText className="h-4 w-4" strokeWidth={2.2} />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="truncate text-[13px] font-semibold text-zinc-900">
                    {u.name}
                  </div>
                  <div className="mt-1 h-1 w-full overflow-hidden rounded-full bg-zinc-100">
                    <div
                      data-testid={`recent-upload-${u.id}-bar`}
                      className="h-full rounded-full transition-[width] duration-150"
                      style={{
                        width: `${u.progress}%`,
                        background: done
                          ? "#10B981"
                          : "linear-gradient(90deg, #0a0a0a 0%, #6D28D9 55%, #22D3EE 100%)",
                      }}
                    />
                  </div>
                  <div className="mt-1 flex items-center gap-2 text-[11px] text-zinc-500">
                    <span>{u.size}</span>
                    <span className="text-zinc-300">·</span>
                    <span data-testid={`recent-upload-${u.id}-progress`}>
                      {u.progress}%
                    </span>
                  </div>
                </div>
                {done ? (
                  <span
                    data-testid={`recent-upload-${u.id}-done`}
                    className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-700"
                  >
                    <Check className="h-3.5 w-3.5" strokeWidth={3} />
                  </span>
                ) : (
                  <span className="flex h-7 w-7 flex-shrink-0 items-center justify-center text-zinc-500">
                    <Loader2 className="h-3.5 w-3.5 animate-spin" strokeWidth={2.4} />
                  </span>
                )}
              </motion.li>
            );
          })}
        </AnimatePresence>
      </ul>
    </section>
  );
}
